module.exports = __webpack_public_path__ + "img/st-10.29241ee9.jpg";